<header class="topbar">

  <button #hamburger class="hamburger" type="button" (click)="uiService.toggleSidebar()"
          aria-controls="panel-lateral"
          [attr.aria-expanded]="menuExpanded()"
          [attr.aria-haspopup]="uiService.sidebarMode() === 'overlay' ? 'dialog' : null"
          [attr.aria-label]="menuLabel()">
    <i class="bi bi-list" aria-hidden="true"></i>
  </button>

  <nav class="crumb" aria-label="Ubicación">
    <i class="bi crumb-icon" aria-hidden="true" [ngClass]="crumb().icon"></i>
    <span class="crumb-text">
      <span class="crumb-title">{{ crumb().title }}</span>
      @if (crumb().hint) {
        <span class="crumb-hint">{{ crumb().hint }}</span>
      }
    </span>
  </nav>

  <div class="spacer"></div>

  <div class="meta">
    <span class="meta-line">
      <i class="bi bi-clipboard-data" aria-hidden="true"></i>
      Encuestas <b class="z-num">{{ uiService.surveyCount | number }}</b>
    </span>
    <span class="meta-line">Actualizado al {{ uiService.updatedAt }}</span>
  </div>

  <button class="z-theme-toggle" type="button" (click)="themeService.toggle()"
          [attr.aria-label]="themeService.theme() === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'">
    <i class="bi" aria-hidden="true"
       [class.bi-sun-fill]="themeService.theme() === 'dark'"
       [class.bi-moon-stars-fill]="themeService.theme() === 'light'"></i>
  </button>

  <div class="profile">
    <button #avatar class="avatar-btn" type="button" (click)="toggleProfile()"
            [attr.aria-expanded]="profileOpen" aria-haspopup="true" aria-label="Perfil">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </button>

    @if (profileOpen) {
      <div class="profile-menu">
        <h6 class="mb-3">Perfil</h6>
        <div class="d-flex align-items-center gap-3 mb-3">
          <span class="avatar-lg"><i class="bi bi-person-fill" aria-hidden="true"></i></span>
          <div>
            <div class="fw-semibold z-text-heading">{{ uiService.userName }}</div>
            <div class="z-text-muted">Periodo {{ uiService.period }}</div>
          </div>
        </div>
        <hr />
        <button class="z-btn z-btn--outline-blue w-100" type="button" (click)="salir()">SALIR</button>
      </div>
    }
  </div>

  <!-- Firma del proveedor. Cierra la misma banda que el logo del cliente abre
       desde la cabecera del panel: extremos opuestos de la fila superior.
       Detrás del filete a propósito — separada de los controles no se lee como
       un botón más, que es el riesgo de meter una marca entre cosas pulsables.
       En `overlay` se queda con el isotipo: ahí no hay panel que muestre el
       logo del cliente y la barra ya va justa de sitio. -->

  <div class="marca">
    @if (uiService.sidebarMode() === 'overlay') {
      <img class="z-vendor-logo" src="assets/images/logo-cleversec-mark.png"
           alt="Cleversec" width="107" height="120" />
    } @else {
      <img class="z-vendor-logo" src="assets/images/logo-cleversec.png"
           alt="Cleversec" width="408" height="160" />
    }
  </div>

</header>
